import { Grid } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import React, { FC } from 'react';
import { styled } from 'styled-components';
import { InputLabels } from '../Buttons';

const Header: FC<{
  onSaveChanges: () => void;
  isFormDataChanged: boolean;
  isSaveAdvisorSettingsLoading: boolean;
}> = ({ onSaveChanges, isFormDataChanged, isSaveAdvisorSettingsLoading }) => {
  return (
    <Grid
      container
      mb="16px"
      justifyContent={'space-between'}
      alignItems={'center'}
    >
      <Grid item alignItems={'center'}>
        <InputLabels
          sx={{
            color: '#000000',
            fontWeight: '500',
            fontSize: '24px',
            margin: 0,
          }}
        >
          Firm Information
        </InputLabels>
      </Grid>
      <Grid item>
        <LoadingButton
          sx={{
            textTransform: 'none',
            background: '#000000',
            width: '160px',
            borderRadius: '20px',
            color: '#ffffff',
            '&:hover': {
              background: '#00C3DE',
              color: '#000000',
              boxShadow: 'none',
            },
            '& .MuiCircularProgress-root': {
              color: '#ffffff',
            },
          }}
          loading={isSaveAdvisorSettingsLoading}
          disabled={!isFormDataChanged || isSaveAdvisorSettingsLoading}
          size="medium"
          variant="contained"
          onClick={onSaveChanges}
        >
          <SaveModelBtnText>Save Changes</SaveModelBtnText>
        </LoadingButton>
      </Grid>
    </Grid>
  );
};

export default Header;

const SaveModelBtnText = styled.span`
  font-size: 14px;
`;
